const NAME = 'ORG_COMMENT_DELETE';

export const REQUEST_DELETE_COMMENT = `${NAME}/REQUEST_DELETE_COMMENT`;
export const COMMENT_DELETE_COMPLETED = `${NAME}/COMMENT_DELETE_COMPLETED`;
export const COMMENT_DELETE_FAILED = `${NAME}/COMMENT_DELETE_FAILED`;
export const RESET_DELETED_STATE = `${NAME}/RESET_DELETED_STATE`;
